module.exports = __webpack_public_path__ + "img/gerenxinxi.fb4cca11.png";